import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import learningPathService from "./logic/learningPathService";
import useDebounce from "../../core/hooks/useDebounce";

const useLearningPaths = (props) => {
  const navigate = useNavigate();

  const [pageOptions, setPageOptions] = useState({page:1,take:20});
  const [searchText, setSearchText] = useState("");
  const { debouncedValue } = useDebounce(searchText, 1000);

  const [filterOptions, setFilterOptions] = useState({searchText:""});

  const onChange = (pagination) => {
    setPageOptions({ ...pageOptions, page: pagination.current, take: pagination.pageSize });
  };

  const getSearchData = (text) => {
    setSearchText(text)
    setFilterOptions({...filterOptions,searchText:text})

  };
  
  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery(
    ["formsData",debouncedValue,pageOptions],
    () => learningPathService.getLearningPaths({pageOptions:JSON.stringify({...pageOptions}),filterOptions:JSON.stringify({...filterOptions})}),
    {
      initialData: {
        data: { data: [], meta: { hasPrevious: false, hasNext: false } },
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );


  // Mutation to delete a learning path
  const deleteLearningPath = useMutation({
    mutationFn: async (id) => learningPathService.deleteLearningPath(id),
    onSuccess: async () => {refetch() },
    onError: async (error) => {},
  });


  const prepData = (data) => {
    // Check if data is available
    if (data) {
      // Map the input data to a new array with selected properties
      return data.map((element) => ({
        id: element.id,
        code: element.code,
        title: element.title, 
        certificates: element.certificateName ? 'yes' : 'no',
      }));
    } else {
      // Return an empty array if input data is not available
      return [];
    }
  };

  const updateFn = (id) => {
    navigate(`/edit-learningPath/${id}`);
  };

  const handleClick = () => {
    navigate(`/learningPathCreation`);
  };



  // Function to initiate learning path deletion
  const deleteFn = async (id) => {
    await deleteLearningPath.mutate(id);
  };

  return {
    data:{data:prepData(data.data.data),meta:data.data.meta},
    isFetching,
    updateFn,
    handleClick,
    deleteFn,
    onChange,
    getSearchData
  };
};

export default useLearningPaths;
